import { Card, Grid, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { ObjectiveReportsSecondarySchoolGraduation } from "generated/openApi";

export const ObjectiveSecondarySchoolGraduation = (props: {
  title: string;
  objective: ObjectiveReportsSecondarySchoolGraduation;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  return (
    <Card header={props.title}>
      <Grid ref={breakpointsRef} container spacing="lg" maxWidth="1000px">
        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              Graduates
            </Typography>
            <Typography variant="h6">{(props.objective.graduatesProportion * 100).toFixed(2)}%</Typography>
          </Stack>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              Graduates who completed rigorous program
            </Typography>
            <Typography variant="h6">
              {(props.objective.graduatesWithRigorousProgramProportion * 100).toFixed(2)}%
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              Participants
            </Typography>
            <Typography variant="h6">{props.objective.participants}</Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};
